export default {
  getGdoDetails: {
    uri: '/devices/{id}',
    needAuthentication: true
  },
  getGdoHistory: {
    uri: '/logs/devices/{id}',
    needAuthentication: true
  },
  filterHomeEventHistory: {
    uri: '/homes/{id}/logs',
    needAuthentication: true
  }
}
